const state = {
    foo: "foo*"
}

const getters = {
    foo: state => state.foo
}

const mutations = {
    setFoo(state, value) {
        state.foo = value
    }
}

const actions = {
    getAllProducts({ commit }) {

        setTimeout(() => {
            commit("setFoo", "this is the new message");
        }, 1000)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
